import { EvaluationStep } from './types';

export interface ResolveResetStepInput {
  // Logado é o gestor imediato do substituído e opera pela lateralidade (LAT-03).
  isDirectManager: boolean;
  // Passo em que a realização está (getTaskStepLocal): 2 aguardando, 3 Nível 1, 4 Nível 2,
  // 4.1 pit stop, 5 Nível 3; undefined quando o status não é reconhecido.
  taskStep: number | undefined;
  // Janela ativa de apreciação da fase selecionada (JAN-01).
  activeStep: EvaluationStep;
  task: { prosseguir_gst?: unknown };
}

// Janelas em que o DESFAZER tem um estado-alvo próprio para realização ADIANTADA:
// 2 → aguardando, 3 → aprovado st1, 4 → promovido st2. Pit stop (4.1) e Nível 3 (5)
// ficam de fora de propósito: nenhuma combinação alcançável existe ali e o pit stop
// não muda (PIT-*).
const JANELAS_COM_ALVO_PROPRIO: ReadonlyArray<EvaluationStep> = [2, 3, 4];

// Passo-alvo do DESFAZER (handleReset dos fluxos Normal e MAD) — RES-01.
//
// Regra geral: o desfazer leva a realização ao estado inicial da JANELA ATIVA, para
// qualquer um que opere (o próprio gestor, um lateral de mesmo nível ou o gestor imediato).
//
// Desvio do gestor imediato (LAT-05, criado em 2026-04-24): quando quem opera pela
// lateralidade é o gestor imediato do substituído e a realização está ATRASADA em relação
// à janela (apreciação expirada) ou não há janela ativa (buraco), o alvo é o passo em que
// a realização está — não se "promove" uma expirada via reset.
//
// Até 2026-10-21 o desvio era aplicado também com a realização ADIANTADA (ex.: promovida
// ao Nível 2 sendo desfeita na janela do Nível 1): regravava o mesmo status e apagava o
// `evaluator`, deixando a realização presa sem avaliador. Agora, adiantada e fora de pit
// stop, vale a janela ativa — exatamente o que o próprio substituído gravaria.
export function resolveResetStep({ isDirectManager, taskStep, activeStep, task }: ResolveResetStepInput): EvaluationStep | number {
  if (!isDirectManager || !taskStep || taskStep === activeStep) return activeStep;

  const adiantada = !!activeStep && taskStep > activeStep;
  const emPitStop = typeof task?.prosseguir_gst === 'string';

  if (adiantada && !emPitStop && JANELAS_COM_ALVO_PROPRIO.includes(activeStep)) return activeStep;

  return taskStep;
}
